import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';

import { Inject, Injectable, Optional } from '@angular/core';
import { AuthToken } from '@core/models/auth.model';
import { OAuthModuleConfig, TokenResponse } from 'angular-oauth2-oidc';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, finalize, switchMap, take, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { BroadcasterService } from './broadcaster.service';
import { CONSTANTS } from './constants';

@Injectable()
export class HTTPReqResInterceptor implements HttpInterceptor {
  isalreadyRefreshing: boolean = false;
  private tokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  router: any;

  constructor(
    private _broadcaster: BroadcasterService,
    private _authservice: AuthService,
    @Optional() private moduleConfig: OAuthModuleConfig
  ) {}

  private checkUrl(url: string): boolean {
    let found = this.moduleConfig.resourceServer.allowedUrls?.find((u) => url.startsWith(u));
    return !!found;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this._broadcaster.broadcast(CONSTANTS.SHOW_LOADER, true);
    /*const newReq = req.clone({
      url: this._baseUrl + req.url,
     // headers: req.headers.set('custom_header', 'value'),
    });*/
    let url = req.url.toLowerCase();
    if (!this.moduleConfig) return next.handle(req);
    if (!this.moduleConfig.resourceServer) return next.handle(req);
    if (!this.moduleConfig.resourceServer.allowedUrls) return next.handle(req);
    if (!this.checkUrl(url)) return next.handle(req);

    let sendAccessToken = this.moduleConfig.resourceServer.sendAccessToken;
    if (sendAccessToken) {
      let token = this._authservice.getToken();
      let header = 'Bearer ' + token;
      let headers = req.headers.set('Authorization', header);
      req = req.clone({ headers });
    }
    return next.handle(req).pipe(
      catchError((err) => {
        if ([401, 403].includes(err.status) && this._authservice.authenticationChanged) {
          // auto logout if 401 or 403 response returned from api
          this._authservice.logout();
        }

        const error = err.error?.message || err.statusText;
        console.error(err);
        return throwError(() => error);
      }),
      finalize(() => {
        this._broadcaster.broadcast(CONSTANTS.SHOW_LOADER, false);
      })
    );
  }

  handleError(newRequest: HttpRequest<any>, next: HttpHandler, err: any) {}

  handleSuccess(body: any) {
    /* handle success actions here */
  }

  addToken(request: HttpRequest<any>, newToken: TokenResponse) {
    return request.clone({
      headers: request.headers.set(CONSTANTS.AUTH_HEADER, `Bearer ${newToken.access_token}`),
    });
  }

  addIdToken(request: HttpRequest<any>, newToken: TokenResponse) {
    return request.clone({
      headers: request.headers.set(CONSTANTS.AUTH_HEADER, `Bearer ${newToken.id_token}`),
    });
  }
}
